import * as THREE from 'three';

import React, { useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';
import { AddIcon } from './formUtil';
import {toast} from 'react-toastify';

import * as helptext from './helptext';

const FormCompress = () => {
  const SetCameraFront  = Control.Get("SetCameraFront");

  const style      = SideStyle();
  const align   = Param.Get('align');
  const baseshape   = Param.Get('baseshape');
  const compress   = Param.Get('compress');
  const setParam   = Param.Get('setParam');
  const setControl = Control.Get('setControl');
  const meshLeg    = Control.Get('meshLeg');

  const [showAdvance, setShowAdvance] = useState(false);
  
  useEffect(() => {
    SetCameraFront();
    toast('Ajust the compression, and go to [Modifying].');
  }, [])
  

  const handleValue = (e) => {
    setParam(s => {s.compress[e.target.name] = Number(e.target.value)});
  };

  const handleValueS = (e) => {
    setParam(s => {s.compress[e.target.name][s.compress.line_no] = Number(e.target.value)});
  };

  const handleValueCompress = (e) => {
    setParam(s => {s.compress[e.target.name][s.compress.line_no] = Number(e.target.value)});
    var mm = compress.manualCircumference[compress.line_no] * (e.target.value / 100 - 1);
    mm = Math.round(mm * 10) / 10;
    setParam(s => {s.compress.compressionMm[s.compress.line_no] = mm});
  };


  function getDisabled(step){
    return !(compress.step == step);
  }

  const nCrossSection = Math.floor((align.stumpLength+align.stumpLengthAdjust) / align.interval)

  return (
    <div className={style.outside}>
      {/* Whole Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Whole Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <TextField
          id="filled-number"
          name='initialAbductionAngle'
          label="Initial abduction angle"
          type="number"
          defaultValue={compress.initialAbductionAngle}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.initialAbductionAngle; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">°</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='°'
            //   helptext={helptext.initialAbductionAngle}
            //   title='Initial abduction angle'
            //   // imgSrc='./static/ak/img/initialAdductionAngle.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-50, 
            max:50,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='initialFlexionAngle'
          label="Initial flexion angle"
          type="number"
          defaultValue={compress.initialFlexionAngle}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.initialFlexionAngle; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">°</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='°'
            //   helptext={helptext.initialFlexionAngle}
            //   title='Initial flexion angle'
            //   // imgSrc='./static/ak/img/initialFlexionAngle.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-50,
            max:50,
            step:1
          }}
        />
      </Grid>
      

      {/* Individual Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Individual Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center' justifyContent="center">
        <TextField
          id="filled-number"
          name='line_no'
          label="Line No."
          type="number"
          defaultValue={compress.line_no}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{ 
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max:nCrossSection,
            step:1
          }}
        />

        
        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 7)
        && <TextField
          id='filled-number'
          name='manualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.manualCircumference[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:10,
            max: 1000,
            step:1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 7)
        && <TextField
          id='filled-number'
          name='tweenFactor'
          label={(nCrossSection>=6) ? 'Ratio X/Y' : 'Tween factor'}
          type='number'
          defaultValue={compress.tweenFactor[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = (nCrossSection >= 6) ? helptext.ratioXY : helptext.tweenFactor;
            s.explanationImg = '';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            //endAdornment: <AddIcon unit='' helptext='helptext.tweenFactor/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max: 1,
            step:0.1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no === 7)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.compressionIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='%' 
            //   helptext={helptext.compressionIndividual}
            //   title='Compression'
            //   // imgSrc='./static/ak/img/compressionIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 6)
        && <TextField
          id='filled-number'
          name='manualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.manualCircumference[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:10,
            max: 1000,
            step:1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 6)
        && <TextField
          id='filled-number'
          name='tweenFactor'
          label={(nCrossSection>=6) ? 'Ratio X/Y' : 'Tween factor'}
          type='number'
          defaultValue={compress.tweenFactor[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = (nCrossSection >= 6) ? helptext.ratioXY : helptext.tweenFactor;
            s.explanationImg = '';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            // endAdornment: <AddIcon unit='' helptext='Tween factor, from 0 to 1, 0 is close to circle'/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max: 1,
            step:0.1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no === 6)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.compressionIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='%' 
            //   helptext={helptext.compressionIndividual}
            //   title='Compression'
            //   // imgSrc='./static/ak/img/compressionIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 5)
        && <TextField
          id='filled-number'
          name='manualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.manualCircumference[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:10,
            max: 1000,
            step:1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 5)
        && <TextField
          id='filled-number'
          name='tweenFactor'
          label={(nCrossSection>=6) ? 'Ratio X/Y' : 'Tween factor'}
          type='number'
          defaultValue={compress.tweenFactor[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = (nCrossSection >= 6) ? helptext.ratioXY : helptext.tweenFactor;
            s.explanationImg = '';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            // endAdornment: <AddIcon unit='' helptext='Tween factor, from 0 to 1, 0 is close to circle'/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max: 1,
            step:0.1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no === 5)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.compressionIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='%' 
            //   helptext={helptext.compressionIndividual}
            //   title='Compression'
            //   // imgSrc='./static/ak/img/compressionIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}


        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 4)
        && <TextField
          id='filled-number'
          name='manualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.manualCircumference[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:10,
            max: 1000,
            step:1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 4)
        && <TextField
          id='filled-number'
          name='tweenFactor'
          label={(nCrossSection>=6) ? 'Ratio X/Y' : 'Tween factor'}
          type='number'
          defaultValue={compress.tweenFactor[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = (nCrossSection >= 6) ? helptext.ratioXY : helptext.tweenFactor;
            s.explanationImg = '';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            // endAdornment: <AddIcon unit='' helptext='Tween factor, from 0 to 1, 0 is close to circle'/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max: 1,
            step:0.1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no === 4)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.compressionIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='%' 
            //   helptext={helptext.compressionIndividual}
            //   title='Compression'
            //   // imgSrc='./static/ak/img/compressionIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 3)
        && <TextField
          id='filled-number'
          name='manualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.manualCircumference[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:10,
            max: 1000,
            step:1
          }}
        />}

        { (compress.line_no <= nCrossSection) 
        && (compress.line_no == 3)
        && <TextField
          id='filled-number'
          name='tweenFactor'
          label={(nCrossSection>=5) ? 'Ratio X/Y' : 'Tween factor'}
          type='number'
          defaultValue={compress.tweenFactor[compress.line_no]}
          fullWidth
          onBlur={handleValueS}
          onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = (nCrossSection >= 5) ? helptext.ratioXY : helptext.tweenFactor;
            s.explanationImg = '';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit=''
            //   helptext={helptext.tweenFactor}
            //   title='tweenFactor'
            //   imgSrc='./static/ak/img/tweenFactor.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max: 1,
            step:0.1
          }}
        />}

        { (compress.line_no === 3)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.compressionIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='%' 
            //   helptext={helptext.compressionIndividual}
            //   title='Compression'
            //   // imgSrc='./static/ak/img/compressionIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}

        {/*}
        { (compress.line_no === 3)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[mm]'
          type='number'
          //defaultValue={compress.compressionMm[compress.line_no]}
          value={compress.compressionMm[compress.line_no]}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext=''/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-50, 
            max:50,
            step:0.5
          }}
        />}
        */}

        { (compress.line_no === 2)
        && <TextField
          id='filled-number'
          name='secondBottomManualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.secondBottomManualCircumference}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:1, 
            max:1000,
            step:1
          }}
        />}

        { (compress.line_no === 2)
        && <TextField
          id='filled-number'
          name='secondBottomRatioXY'
          label={(nCrossSection>=4) ? 'Ratio X/Y' : 'Tween factor'}
          type='number'
          defaultValue={compress.secondBottomRatioXY}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = (nCrossSection >= 5) ? helptext.ratioXY : helptext.tweenFactor;
            s.explanationImg = '';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='' 
            //   helptext={helptext.ratioXY}
            //   title='Ratio X/Y'
            //   imgSrc='./static/ak/img/ratioXY.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0.1, 
            max:2,
            step:0.05
          }}
        />}

        { (compress.line_no === 2)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          InputProps={{
            endAdornment: 
            <AddIcon 
              unit='%' 
              helptext={helptext.compressionIndividual}
              title='Compression'
              // imgSrc='./static/ak/img/compressionIndividual.png'
            />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}


        { (compress.line_no === 1)
        && <TextField
          id='filled-number'
          name='bottomManualCircumference'
          label='Manual circumference'
          type='number'
          defaultValue={compress.bottomManualCircumference}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.circumferenceIndividual; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.circumferenceIndividual}
            //   title='Circumference'
            //   // imgSrc='./static/ak/img/circumferenceIndividual.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:1, 
            max:1000,
            step:1
          }}
        />}

        { (compress.line_no === 1)  
        && <TextField
          id='filled-number'
          name='bottomRatioXY'
          label='Ratio X/Y'
          type='number'
          defaultValue={compress.bottomRatioXY}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {
            s.explanationText = helptext.ratioXY;
            s.explanationImg = './static/ak/img/ratioXY.png';
          })}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='' 
            //   helptext={helptext.ratioXY}
            //   title='Ratio X/Y'
            //   imgSrc='./static/ak/img/ratioXY.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0.1, 
            max:2,
            step:0.05
          }}
        />}

        { (compress.line_no === 1)  
        && <TextField
          id='filled-number'
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={compress.compression[compress.line_no]}
          fullWidth
          onBlur={handleValueCompress}
          onKeyDown={e => {if (e.key === 'Enter') handleValueCompress(e);}}
          InputProps={{
            endAdornment: 
            <AddIcon 
              unit='%' 
              helptext={helptext.compressionIndividual}
              title='Compression'
              // imgSrc='./static/ak/img/compressionIndividual.png'
            />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />}


        { (compress.line_no === 0) 
        && <TextField
          id='filled-number'
          name='bottomExtensionCurveRadius'
          label='Radius'
          type='number'
          defaultValue={compress.bottomExtensionCurveRadius}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.bottomExtensionCurveRadius; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.bottomExtensionCurveRadius}
            //   title='Radius'
            //   // imgSrc='./static/ak/img/bottomExtensionCurveRadius.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:5, 
            max:100,
            step:1
          }}
        />}

        { (compress.line_no === 0) 
        && <TextField
          id="filled-number"
          name='bottomExtensionAk'
          label="Bottom Extension"
          type="number"
          defaultValue={compress.bottomExtensionAk}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.bottomExtensionAk; s.explanationImg = ''})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.bottomExtensionAk}
            //   title='Bottom Extension'
            //   // imgSrc='./static/ak/img/bottomExtensionAk.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0, 
            max:100,
            step:1
          }}
        />}
      </Grid>
      
      <button className={style.buttonShowHide} onClick={() => setShowAdvance(prev => !prev)}>SHOW/HIDE Advance settings</button>
      {showAdvance && <div>
        <TextField
          id="filled-number"
          name='intervalAk'
          label="Interval"
          type="number"
          defaultValue={compress.intervalAk}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            //https://codesandbox.io/s/69554151-how-to-change-material-ui-textfield-inputadornment-background-color-b8kqn?file=/demo.js
            //https://stackoverflow.com/questions/56811449/how-to-style-adornment-in-mui-textfield 
            endAdornment: <AddIcon unit="mm" helptext="Interval of cross sections"/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:20, 
            max:100,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='compressionWhole'
          label="Compression"
          type="number"
          defaultValue={compress.compressionWhole}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: <AddIcon unit="%" helptext="Socket compression rate. It is depending on interfaces"/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:80, 
            max:120,
            step:1
          }}
        />
      </div>}
      

      {/* Buttons */}
      {/*
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Button className={style.button} onClick={onCreateSocket}>Create Socket</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={style.button} onClick={onClear} disabled={getDisabled(2)}>Clear Socket</Button>
        </Grid>
      </Grid>
      */}
    </div>
  );
}
export default FormCompress;
